import { useEffect } from 'react';
import { Provider, useOfflineContext } from './Provider';
import OfflineQueue from './OfflineQueue';
import { classNames } from '../../Services/helpers';
import Callback from '../../Services/Callback';

const syncCompleteCallback = new Callback();

const offlineStatus = {
    PENDING: 'Pending',
    SYNCED: 'Synced',
    OFFLINE: 'Offline',
    SYNCING: 'Syncing',
    COMPLETE: 'Complete',
    ERROR: 'Error',
}

const Offline = (props) => {
    return <Provider {...props}>
        {props.children}
    </Provider>
};

const Status = ({className}) => {
    const {status, sync} = useOfflineContext();

    if (!status) {
        return null;
    }

    const classes = {
        [offlineStatus.PENDING]: 'bg-brand text-white',
        [offlineStatus.SYNCING]: 'bg-brand text-white',
        [offlineStatus.ERROR]: 'bg-red-500 text-white',
        [offlineStatus.COMPLETE]: 'bg-green-500 text-white',
        [offlineStatus.OFFLINE]: 'bg-gray-500 text-white',
    }

    const message = {
        [offlineStatus.PENDING]: 'Offline changes pending.',
        [offlineStatus.SYNCING]: 'Syncing offline changes...',
        [offlineStatus.ERROR]: 'There was an error syncing offline changes. More info.',
        [offlineStatus.COMPLETE]: 'Sync complete.',
        [offlineStatus.OFFLINE]: 'You are offline. Data may be out of date and changes may not be saved.',
    }

    const onClicks = {
        [offlineStatus.PENDING]: sync,
        [offlineStatus.SYNCING]: null,
        [offlineStatus.ERROR]: sync,
        [offlineStatus.COMPLETE]: null,
        [offlineStatus.OFFLINE]: sync,
    }

    return <div className={classNames(className, classes[status] ?? 'bg-gray-500 text-white')}
        onClick={onClicks[status]}
    >
        {message[status]}
    </div>
}

const useSyncComplete = (callback) => {
    useEffect(
        () => syncCompleteCallback.listen(callback),
        [callback]
    );
}

export default Offline;

export {
    useOfflineContext as useOffline,
    OfflineQueue,
    offlineStatus,
    Status,
    syncCompleteCallback,
    useSyncComplete,
}
